import { DCEvent } from "@/events/eventsDomain";
import { Language } from "@/i18n/languages";
import { ThemePreference } from "@/theme/themeDomain";

export type UserPrefs = {
  lang?: Language;
  theme?: ThemePreference;
  schedule?: {
    sortOrder?: "asc" | "desc";
  };
  dismissedAlerts?: {
    webinar?: boolean;
    signingImprovements?: boolean;
    importArticles?: boolean;
  };
  dismissedAnnouncement?: string;
  portfolioQuickFiltersExpanded?: boolean;
};

export const initUserPrefs = (): UserPrefs =>
  JSON.parse(localStorage.getItem("user-prefs") ?? "{}") ?? {};

const storeUserPrefs = (): DCEvent => ({
  type: "with-store",
  events: ({ userPrefs }) => [{ type: "update-local-storage", key: "user-prefs", val: userPrefs }],
});

export const updateUserPrefEvent = <T extends keyof UserPrefs>(
  key: T,
  val: UserPrefs[T],
): DCEvent[] => [
  { type: "update-store", data: { userPrefs: (cur) => ({ ...cur, [key]: val }) } },
  storeUserPrefs(),
];

export const dismissAlert = (
  userPrefs: UserPrefs | undefined,
  key: keyof NonNullable<UserPrefs["dismissedAlerts"]>,
): DCEvent[] => [
  {
    type: "update-store",
    data: {
      userPrefs: {
        ...userPrefs,
        dismissedAlerts: { ...userPrefs?.dismissedAlerts, [key]: true },
      },
    },
  },
  storeUserPrefs(),
];
